import badgeImg from "assets/images/icons/badge.png";
// import { Fade } from "react-awesome-reveal";

const GradientCard = () => {
  return (
    <div className="gradientCard">
        {/* <Fade direction="up" triggerOnce delay={750} duration={1400}> */}
        {/* <Fade direction="down" triggerOnce delay={800} duration={1200}> */}
          <p>
            Join 250,000+ moms <br />
            already using MamaZen to <br />
            enjoy motherhood more <br />
            and raise happier kids
          </p>
        {/* </Fade> */}
        {/* <Fade direction="up" triggerOnce delay={900} duration={1400}> */}
          <img src={badgeImg} alt="" />
        {/* </Fade> */}
        {/* </Fade> */}
      </div>
  );
};

export default GradientCard;
